import React, { useState, FormEvent, useEffect, WheelEventHandler } from 'react';
import { useParams } from 'react-router-dom';

import {Suggest2, Suggest, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, Alert, Dialog, DialogBody, Callout, Checkbox, Tooltip } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation ,Icon} from "@blueprintjs/core";
//import { DateInput3 } from "@blueprintjs/datetime2";
import { IconNames } from "@blueprintjs/icons";
import { AxiosInstance } from 'axios';
import * as utils from "./utils";
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next';
import svgWait2 from './svg/wait2.gif'
import { Account, CurrencyInfo,StkCodeInfo, PlacingInfo,sbConfig} from './Types'
import { SystemHeader,ClientPicker } from './CommonUI';
import i18next from 'i18next';
import { access } from 'fs';

import svgcaretdown from './svg/caret-down.svg'

interface PageInfo {
    n: number
}

interface PageInfo2 {
    pageno: number,
    pageShow: boolean,
    pageStartno: number,
    pageEndno: number,
    pageLast: boolean,
}


var GsbFlag: any;

var UserID: string;
var PgmCode = "H0025" ;
var isReqAuth2:boolean = false ;
/*
interface PlacingMastViewProps {
    gsb: AxiosInstance,
    Placing: FiniInfo,
    Placing0: FiniInfo,
    CurrencyList?: CurrencyInfo[],
    GsbConfig: sbConfig,
    baseUrl?: string,
    token?: string | null,
    onPrevRec?: () => void,
    onNew?: () => void,
    onEdit?: () => void,
    onDelete?: () => void,
    onNextRec?: () => void,
    ViewMode: any,
    logKey2: any,
    PgmMode: any,    
}

*/
interface PlacingMastViewProps {
    gsb: AxiosInstance,
    Placing: PlacingInfo,
    Placing0: PlacingInfo, 
    CurrencyList?: CurrencyInfo[],
    GsbConfig: sbConfig,
    baseUrl?: string,
    token?: string | null,
    onPrevRec?: () => void,
    onNew?: () => void,
    onReplicate?: () => void,  
    onEdit?: () => void,
    onDelete?: () => void,
    onNextRec?: () => void,
    ViewMode: any,
    logKey2: any,
    PgmMode:any,    
}




function PlacingMastView({ gsb, Placing = {} as PlacingInfo,Placing0 = {} as PlacingInfo, CurrencyList =[] as CurrencyInfo[],  GsbConfig = {} as sbConfig, baseUrl = "", token = "", onPrevRec = () => { }, onNew = () => { }, onEdit = () => { }, onDelete = () => { }, onNextRec = () => { }, ViewMode, logKey2 ,PgmMode}: PlacingMastViewProps) {

    const { t, i18n } = useTranslation();       
    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)
    const [isDeletePress, setisDeletePress] = useState(false)
    const [isCanDelete, setisCanDelete] = useState(true)
    const [isDeletePress2, setisDeletePress2] = useState(false)

 

    const [isOpenDialog, setisOpenDialog] = useState(false)
    const [isOPenAlert, setisOPenAlert] = useState(false)
    const [cAction, setcAction] = useState("")
    const [AuthUser, setAuthUser] = useState("")
    const [password, setPassword] = useState("")

    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")
    const [AcName1Value, setAcName1Value] = useState("")
    const [AcName2Value, setAcName2Value] = useState("")


    const [AcStatusValue, setAcStatusValue] = useState("")

    //Listed cannnot ammmed
    const [FiniListStatusValue,setFiniListStatisValue] = useState(false)

    let logKey3a = logKey2.substr(0,logKey2.indexOf("*")); 
    let logKey3b = logKey2.substr(logKey2.indexOf("*")+1); 
    let logKey3c = logKey3b.substr(logKey3b.indexOf("*")+1); 
    logKey3b = logKey3b.substr(0,logKey3b.indexOf("*")); 
    logKey3c = logKey3c.substr(0,logKey3c.indexOf("*")); 

    const [PrevDayValue, setPrevDayValue] = useState(0)
    const [LatestBalValue, setLatestBalValue] = useState(0)
    const [UnClrChqValue, setUnClrChqValue] = useState(0)
 

    const [showSIMore, setshowSIMore] = useState(true)

 
     const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    useEffect(() => {
        setisReadOnly(false)
        setisReqAuth(false)
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    //console.log("PlacingMastView UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            setisReqAuth(true)
                            isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID, Placing])


    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }




    if (! ("d_StkNo" in Placing)) return null
/*

    const AcNOToolTip = 
    <div>
        <div>Account No. </div>
        <div>Cash A/C : ACCOUNT=Axxxx, CUSTODY=Pxxxx </div> 
        <div>Margin A/C : MARGIN=Mxxxx </div> 
        <div>RUNNER=Cxxxx, INTERNAL=Ixxxx </div> 
   </div>

*/

    return (
        <div>
            {/* define add,change,delete button */}
            {ViewMode === "V" &&<div className="Row">
                <Button className="Col-1-1" icon="direction-left" onClick={() => onPrevRec()} >Prev</Button>
                
                {/* <Button className="Col-2-1" icon="add" onClick={() => onNew()} >New</Button>
                <Button className="Col-3-1" icon="edit" onClick={() => onEdit()} >Edit</Button>
                <Button className="Col-4-1" icon="delete" onClick={() => onDelete()} >Delete</Button> */}
          
                <Button className="Col-2-1" disabled={isReadOnly} icon="add" onClick={() => onNew() } >New</Button>
                <Button className="Col-3-1" disabled={isReadOnly} icon="edit" onClick={() => onEdit() } >Edit</Button>
                <Button className="Col-4-1" disabled={isReadOnly} icon="delete" onClick={() => setisDeletePress(true)} >Delete</Button>
                    <Alert
                        cancelButtonText="Cancel"
                        confirmButtonText="Delete"
                        canEscapeKeyCancel={true}
                        icon="trash"
                        intent={Intent.DANGER}
                        isOpen={isDeletePress}
                        onCancel={ () => setisDeletePress(false) }
                        onConfirm={ () => { onDelete(); setisDeletePress(false) } }
                    >
                        <p>
                            Are you sure to Delete ?
                        </p>
                    </Alert>
                
                <Button className="Col-5-1" icon="direction-right" onClick={() => onNextRec()} >Next</Button>
                {/* <Button className="Col-7-2" icon="document" onClick={() => { window.open(`/#/BookClosedQty?Stkno=${Placing.d_StkNo}?IPONo=${Placing.d_IPONo}`, '_blank') } } >Book Closed Qty</Button> */}
            </div>}
            <div className="Spacing-V-16" />

            { ViewMode === "L" && <div>
                Account No. : {Placing.d_StkCode}
                { (logKey2.indexOf("*A1") > 0 ) && <div id="DispText2">Action : {logKey3a} {logKey3b} User {logKey3c} Amend</div> }
                { (logKey2.indexOf("*C") > 0 ) && <div id="DispText2">Action : {logKey3a} {logKey3b} User {logKey3c} Create</div> }
                { (logKey2.indexOf("*D") > 0 ) && <div id="DispText2">Action : {logKey3a} {logKey3b} User {logKey3c} Delete</div> }
                { ! (Placing.d_AuthId.toString() == "") && <div id="DispText2">Auth : {utils.dispDate(Placing.d_AuthDate, "3")} {Placing.d_AuthTime} User {Placing.d_AuthId} </div> }
                <div className="Spacing-V-16" />
            </div> }


            <div className="Spacing-V-16" />

      

            <div className="Row">

                <FormGroup className="Col-1-3" label="Stock No." labelFor="inputStkNo">
                    <InputGroup readOnly value={Placing.d_StkNo} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Placing0.d_StkNo.toString() == "") && 
                    <div id="DispText2" > {Placing0.d_StkNo} </div> }
                </FormGroup>
               <FormGroup className="Col-4-3" label="Stock Code" labelFor="inputStkCode">
                    <InputGroup readOnly value={Placing.d_StkCode} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Placing0.d_StkCode.toString() == "") && 
                    <div id="DispText2" > {Placing0.d_StkCode} </div> }
                </FormGroup>   

                <FormGroup className="Col-1-3" label="Stock Name" labelFor="inputStkName">
                    <InputGroup readOnly value={Placing.d_StkName} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Placing0.d_StkName.toString() == "") && 
                    <div id="DispText2" > {Placing0.d_StkName} </div> }
                </FormGroup>   

                <FormGroup className="Col-4-3" label="Stock Name(Big5)" labelFor="inputChi_Name_bg5">
                    <InputGroup readOnly value={Placing.d_Chi_Name_bg5} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Placing0.d_Chi_Name_bg5.toString() == "") && 
                    <div id="DispText2" > {Placing0.d_Chi_Name_bg5} </div> }
                </FormGroup>   

            </div>
            <div className="Row">     
                <FormGroup className="Col-1-2" label="Apply Price.">
                    <InputGroup readOnly value={utils.formatNumber(Placing.d_ApplyPrice)} />   
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Placing0.d_ApplyPrice.toString() == "") && 
                    <div id="DispText2" > {(Placing0.d_ApplyPrice)} </div> }
                </FormGroup >

              <FormGroup className="Col-1-2" label="Lot Size">
                    <InputGroup readOnly value={utils.formatNumber(Placing.d_LotSize)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Placing0.d_LotSize.toString() == "") && 
                    <div id="DispText2" > {(Placing0.d_LotSize)} </div> }
                </FormGroup >

                <FormGroup className="Col-3-1" label="Currency.">
                    <InputGroup readOnly value={utils.formatNumber(Placing.d_Currency)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Placing0.d_Currency.toString() == "") && 
                    <div id="DispText2" > {(Placing0.d_Currency)} </div> }
                </FormGroup >
            </div>                
            <div className="Row">   
                <FormGroup className="Col-1-2" label="Appy Date.">
                    <InputGroup readOnly value={utils.dispDate(Placing.d_ApplyDate,GsbFlag.dateFormat)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Placing0.d_ApplyDate.toString() == "") && 
                    <div id="DispText2" > {utils.dispDate(Placing.d_ApplyDate, GsbFlag.dateFormat)} </div> }
                </FormGroup>
                <FormGroup className="Col-3-2" label="Listing Date.">
                    <InputGroup readOnly value={utils.dispDate(Placing.d_ListingDate, GsbFlag.dateFormat)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Placing0.d_ListingDate.toString() == "") && 
                    <div id="DispText2" > {utils.dispDate(Placing0.d_ListingDate, GsbFlag.dateFormat)} </div> }
                </FormGroup>

            </div>
            <div className="Spacing-V-16" />
    
        
        

            <div className="Row">
                 <FormGroup className="Col-1-2" label="Comm Rate.(%)">
                     <InputGroup readOnly value={(utils.ParseFloat(Placing.d_CommRate,4)).toString()} />
                     { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Placing0.d_CommRate.toString() == "") && 
                     <div id="DispText2" > {utils.ParseFloat(Placing0.d_CommRate,4)} </div> }
                 </FormGroup >  
 
                 <FormGroup className="Col-1-2" label="CCASS Stock">
                    {/* <InputGroup readOnly value={stk.d_CcassStk} /> */}
                    {/* <Checkbox label="CCASS Stock" disabled={true} checked={(stk.d_CcassStk==="Y")} onChange={()  => {} } /> */}
                    {/* <input readOnly type="checkbox" checked={(stk.d_CcassStk==="Y")} /> CCASS */} 
                    {/* ( ViewMode === "V" || (ViewMode === "L" && stk.d_CcassStk.trim().length > 0) ) && <Switch readOnly id="inputCcassStk" label="" innerLabelChecked="CCASS" innerLabel="non-CCASS" checked={(stk.d_CcassStk==="Y")} /> */}
                    <RadioGroup
                        name="d_CCASStock"
                        disabled={true}
                        inline={true}
                        selectedValue={Placing.d_CCASStock}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                </FormGroup>
                 <FormGroup className="Col-1-2" label="Contract Stamp">
                    <RadioGroup
                        label="" 
                        name="d_Stamp"
                        disabled={true}
                        inline={true}
                        selectedValue={Placing.d_Stamp}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                </FormGroup>
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-2" label="Transaction Levy Rate.">
                    <InputGroup readOnly value={utils.numToString(Placing.d_LevyRate)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Placing0.d_LevyRate.toString() == "") && 
                    <div id="DispText2" > {(Placing0.d_LevyRate)} </div> }
                </FormGroup >

                <FormGroup className="Col-3-2" label="AFRC Levy Rate.">
                    <InputGroup readOnly value={utils.numToString(Placing.d_AfrcLevyRate)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Placing0.d_AfrcLevyRate.toString() == "") && 
                    <div id="DispText2" > {(Placing0.d_AfrcLevyRate)} </div> }
                </FormGroup >

                <FormGroup className="Col-5-2" label="Trading Fee Rate(%)">
                    <InputGroup readOnly value={utils.numToString(Placing.d_TradingFeeRate)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Placing0.d_TradingFeeRate.toString() == "") && 
                    <div id="DispText2" > {(Placing0.d_TradingFeeRate)} </div> }
                </FormGroup >
            

                <FormGroup className="Col-7-2" label="Nominee Handling Fee">
                    <InputGroup readOnly name="d_HandlingFee" defaultValue={utils.numToString(Placing.d_HandlingFee)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Placing0.d_HandlingFee.toString() == "") && 
                    <div id="DispText2" > {Placing0.d_HandlingFee} </div> }
                </FormGroup >
            </div>
            <div className="Spacing-V-16" />


 
 
      
   
        </div>
    )
}

interface PlacingMastEditProps {
    gsb: AxiosInstance,
    Placing?: PlacingInfo,
    CurrencyList?: CurrencyInfo[],
    GsbConfig?: sbConfig,
    isNew?: boolean,
    onSave?: (stk: PlacingInfo) => void,
    onCancel?: () => void,
    PgmMode: any,    
}


function PlacingMastEdit({ gsb, Placing = {} as PlacingInfo, CurrencyList=[] as CurrencyInfo[],  GsbConfig = {} as sbConfig, isNew = false, onSave = () => { }, onCancel = () => { } ,PgmMode}: PlacingMastEditProps) {

    const [isReqAuth, setisReqAuth] = useState(false)    
    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<PlacingInfo>()
    const imgCaretdown = <img className="downIcon" src={svgcaretdown} alt="caretdown" />
    const { t, i18n } = useTranslation();       
    const [StkCodeList, setStkCodeList] = useState([] as StkCodeInfo[])  
   // const [AcCodeValue, setAcCodeValue] = useState(Placing.d_acCode)
   // const [setClCodeValue, setSetClCodeValue] = useState(() => setAcCodeValue)
    const [isClPickerOpen, setIsClPickerOpen] = useState(false)   
    //const [AcCodeList, setAcCodeList] = useState([] as AcCodeInfo[])
    const [searchStk,setsearchStk] = useState("")    
    const [CurrencyValue,setCurrencyValue] = useState(Placing.d_Currency)
    const [StkValue ,setStkValue] = useState (Placing.d_StkCode)
    const [StkNoValue,setStkNoValue] = useState(Placing.d_StkNo)     
    const [StkNameValue,setStkNameValue] = useState(Placing.d_StkName)

    const [StkBig5NameValue,setBig5StkNameValue] = useState(Placing.d_Chi_Name_bg5)

    //const [AcName1Value, setAcName1Value] = useState(Placing.d_acName1)    
    //const [AcName2Value, setAcName2Value] = useState(Placing.d_acName2)
  
    const [AcStatusValue, setAcStatusValue] = useState("")
 
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")
    const [showChannel, setshowChannel] = useState(false)
    const [showMULTI_PRCE, setshowMULTI_PRCE] = useState(false)
    
    const [HandlingFeeValue, setHandlingFeeValue] = useState(utils.numToString(Placing.d_HandlingFee))

    const[CommRateValue,setCommRateValue] = useState(utils.numToString(Placing.d_CommRate))
    const[d_AFRCLevyRate,setd_AFRCLevyRate] = useState(utils.numToString(Placing.d_AfrcLevyRate))       //AFRC rate 0.00015      
    const [CCassValue,setCCassValue ] = useState(Placing.d_CCASStock)
    const [StampValue,setStampValue ] = useState(Placing.d_Stamp)
 
    const [d_StkName,setd_StkName] = useState("")


    const [ApplyPriceValue ,setApplyPriceValue] = useState(utils.numToString(Placing.d_ApplyPrice))
   // const [ApplyQtyValue ,setApplyQtyValue] = useState(utils.numToString(Placing.d_ApplyQty))

    
    
    const [LotSizeValue ,setLotSizeValue] = useState(utils.numToString(Placing.d_LotSize))
    
 

    //Trading Fee (%)
    const [SLevy_RateValue, setSLevy_RateValue] = useState(utils.numToString(Placing.d_TradingFeeRate))
    //levy rate
    const [Levy_RateValue, setLevy_RateValue] =   useState(utils.numToString(Placing.d_LevyRate))

   
    const [AFRCFLevy_RateValue, setAFRCFLevy_RateValue] = useState(utils.numToString(Placing.d_AfrcLevyRate))

      useEffect(() => {
          (async () => {
              try {               
                //etHandlingFeeValue(utils.numToString("100"))
                   if(isNew)
                  {
                    setLevy_RateValue(GsbConfig.x_LEVY_RATE)          //Transaction Levy (%) x_LEVY_RATE
                    setAFRCFLevy_RateValue(GsbConfig.x_FLEVY_RATE)   //Trading Fee (%)  ..x_SLEVY_RATE
                    setSLevy_RateValue(GsbConfig.x_SLEVY_RATE)      //Trading Fee (%)
              
                    

                  }
                  else
                  {
                    //setLevy_RateValue(GsbConfig.x_LEVY_RATE) 
                    //setSLevy_RateValue(GsbConfig.x_SLEVY_RATE)
                    //setFLevy_RateValue(GsbConfig.x_FLEVY_RATE)
      
                    setAFRCFLevy_RateValue(utils.numToString(Placing.d_AfrcLevyRate))
                  }
                  
              } catch (error) {
                  //utils.showError(error)
              }
          })()
      }, [  ])
  
       
    
    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
                // setuserKey(GsbFlag.user_key)
                // setGSBx_USER(GsbFlag.GSBx_USER) ;
                // setdateFormat(GsbFlag.dateFormat)
            } catch (error) {
                //utils.showError(error)
            }
        })()
    }, [gsb, GsbConfig ])

  

 
    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
 
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }

                setshowChannel( GsbFlag.MULTI_CHNL ) ;
                setshowMULTI_PRCE( GsbFlag.MULTI_PRCE ) ;

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])  

   

 
    useEffect(() => {
        // Call reset to get the values of record StkInfo 
        if ("d_StkNo" in Placing) {
            reset(Placing)
        }
    }, [Placing, reset])


    useEffect(() => {
        // Suggest don't have ref to use with react-hook-form, so register it manually and call setValue when item is selected
        register({ name: "d_Currency" })   
        //register({ name: "d_status" })
    
    }, [register])


    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])

     
 
 
  
    if (! isNew && ! ("d_StkNo" in Placing)) return null


    const onSubmit = (data: PlacingInfo) => {

        data.d_StkCode = data.d_StkCode.toUpperCase();
        data.d_StkName = data.d_StkName.toUpperCase();
        //data .d_StkCode
        data.d_LevyRate =utils.StringToNum(Levy_RateValue);
        data.d_AfrcLevyRate = utils.StringToNum(AFRCFLevy_RateValue);               
        data.d_TradingFeeRate = utils.StringToNum(SLevy_RateValue);
        data.d_CCASStock = CCassValue;
        data.d_Stamp = StampValue;
        data.d_HandlingFee = utils.StringToNum(HandlingFeeValue);
        data.d_LevyRate = utils.StringToNum(Levy_RateValue);
        data.d_ApplyPrice =  utils.StringToNum(ApplyPriceValue);
        data.d_LotSize = utils.StringToNum(LotSizeValue);
 
        data.d_CommRate = utils.StringToNum(CommRateValue)
        data.d_Currency = CurrencyValue

           //data.d_tr
        data.d_AuthTran = ""
        if (isReqAuth) {
            data.d_AuthTran = "Y"
        }

        (async () => {
            try {
                console.log("call PlacingMastEdit data", data)
                console.log("call PlacingMastEdit isNew", isNew)
                const res = await gsb.post('/Master', {sb_data: data, cPgmId: "PlacingMast", cAction: "PlacingMastValidate", isNew: isNew})
                if (! res.data.ok) {
                    for (let j = 0; j < res.data.data.length; j++) {
                        setError(res.data.data[j][0], {
                            message: res.data.data[j][1]
                        }); 
                    }
                    return
                }
                else
                {
                    onSave(data)
                }
            } catch (error) {
                ///  showErrorBox(error)

                utils.showError(error)
            }
        })()
        
    }
    
    const CurrencyRenderer: ItemRenderer<CurrencyInfo> = (CurrencyList, { handleClick, modifiers, query }) => {
        if (!modifiers.matchesPredicate) {
            return null;
        }
        const text = `${CurrencyList.d_CcyDesc}`;
        return (
            <MenuItem
                active={modifiers.active}
                disabled={modifiers.disabled}
                label={CurrencyList.d_Currency}
                key={CurrencyList.d_Currency}
                onClick={handleClick}
                text={highlightText(text, query)}
            />
        );
    };
       
    const CurrencyPredicate: ItemPredicate<CurrencyInfo> = (query, CurrencyList, _index, exactMatch) => {
        const normalizedText = `${CurrencyList.d_Currency} - ${CurrencyList.d_CcyDesc}`.toLowerCase();
        const normalizedQuery = query.toLowerCase();

        if (exactMatch) {
            return normalizedText === normalizedQuery;
        } else {
            return normalizedText.indexOf(normalizedQuery) >= 0;
        }
    };
       
    const CurrencyValueRenderer = (CurrencyList: CurrencyInfo) => {
        return CurrencyList.d_Currency
    }

       
    function highlightText(text: string, query: string) {
        let lastIndex = 0;
        const words = query
            .split(/\s+/)
            .filter(word => word.length > 0)
            .map(escapeRegExpChars);
        if (words.length === 0) {
            return [text];
        }
        const regexp = new RegExp(words.join("|"), "gi");
        const tokens: React.ReactNode[] = [];
        while (true) {
            const match = regexp.exec(text);
            if (!match) {
                break;
            }
            const length = match[0].length;
            const before = text.slice(lastIndex, regexp.lastIndex - length);
            if (before.length > 0) {
                tokens.push(before);
            }
            lastIndex = regexp.lastIndex;
            tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
        }
        const rest = text.slice(lastIndex);
        if (rest.length > 0) {
            tokens.push(rest);
        }
        return tokens;
    }
       
    function escapeRegExpChars(text: string) {
        //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return text.replace(/([.*+?^=!:${}()|\\])/g, "\\$1");
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }
       
       
    const handleViewInfoClick = (event: any): void => {
        event.preventDefault()    
        
        } 

    const stkCodeIsUnique = async (i_StkCode: string) => {
    /*        
            (async () => {
                try {
                    // get Stock Code List
                    const res = await gsb.post('/Master', {sb_data: "", cPgmId: "Smmast", cAction: "StkCodeList"})
                    console.log("StkCodeList: ", res.data.data) 
                    //setStkCodeList(res.data.data)
                    //console.log("set StkCodeList: ", StkCodeList) 
                } catch (error) {
                    showErrorBox(error)
                }
            })()


            let i = 0 ;
            let l_stkcode = false;
            //console.log("SmMastEdit StkCodeList ", StkCodeList.length, StkCodeList) ;
            //console.log("SmMastEdit i_StkCode ", i_StkCode) ;
            //console.log("SmMastEdit stk.d_StkNo1: ", stk.d_StkNo) ;
            //console.log("SmMastEdit GsbFlag: ", GsbFlag)
            for (i = 0; i < StkCodeList.length; i++) {
                if ( StkCodeList[i].d_StkCode.trim() === i_StkCode.trim() ){
                    //console.log("SmMastEdit StkCodeList.d_StkNo:", utils.STRVAL(GsbFlag, StkCodeList[i].d_StkNo) );
                    //console.log("SmMastEdit        stk.d_StkNo2:", utils.STRVAL(GsbFlag, stk.d_StkNo) );
                    if ( utils.STRVAL(GsbFlag, StkCodeList[i].d_StkNo) === utils.STRVAL(GsbFlag, stk.d_StkNo) )
                    {
                        l_stkcode = true;
                        //console.log("SmMastEdit l_stkcode:  ", l_stkcode) ;
                        break
                    }
                    break
                }
            }
            console.log("SmMastEdit i:  ", i, StkCodeList.length) ;
            if ( i === StkCodeList.length ) 
            {
                l_stkcode = true;
            }
            return l_stkcode;
    */        
            return true;

        }

    /*<form onSubmit={handleSubmit(onSubmit)}>*/
    return (
        <form onKeyDown={handleHotkey}>
        
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Cancel</Button>
                <Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>Save</Button>

            </div>
     
            <div className="Spacing-V-16" />


            <div className="Row">

                <FormGroup className="Col-1-3" label="Stock No." labelFor="inputStkNo" labelInfo="*">
                    <InputGroup disabled={! isNew} id="inputStkNo" name="d_StkNo" autoFocus={isNew} defaultValue="" inputRef={register({ required: true ,maxLength:6}) } />
                    {errors.d_StkNo && errors.d_StkNo.type === "required" && (<span id="Err_msg">Stock No. cannot be Blank</span>)}
                    {errors.d_StkNo && errors.d_StkNo.type === "maxLength" && (<span id="Err_msg">Stock No. lenght is 6 max</span>)}
                    {/* GsbErrors[0].field_error &&<span id="Err_msg">{GsbErrors[0].field_message}</span> */}
                    {errors.d_StkNo && errors.d_StkNo.types && <span id="Err_msg">{errors.d_StkNo.types.message}</span>}
                </FormGroup>


                <FormGroup className="Col-4-3" label="Stock Code." labelFor="inputStkCode" labelInfo="*">
                    <InputGroup id="inputStkCode" name ="d_StkCode"  defaultValue="" placeholder="Stock Code..."  inputRef={register({ required: true,maxLength:15 }) } />
                    {errors.d_StkCode && errors.d_StkCode.type === "maxLength" && (<span id="Err_msg">Stock No. lenght is 15 max</span>)}
                    {errors.d_StkCode && errors.d_StkCode.type === "required" && <span id="Err_msg">Stock Code cannot be Blank</span>}              
                    {errors.d_StkCode && errors.d_StkCode.types && <span id="Err_msg">{errors.d_StkCode.types.message}</span>}
                </FormGroup>

           
            </div>                
            <div className="Row">
                
                <FormGroup className="Col-1-3" label="Stock Name" labelFor="inputStkName">
                    <InputGroup id="inputStkName" name="d_StkName" defaultValue={d_StkName} placeholder="Stock Name ..." onChange={utils.handleStringChange(n => setd_StkName(n))}  inputRef={register({ maxLength: 45}) } />
                    {errors.d_StkName && errors.d_StkName.type === "maxLength" && <span id="Err_msg">Max length is 45</span>}
                    <div>
                        {errors.d_StkName && errors.d_StkName.types && <span id="Err_msg">{errors.d_StkName.types.message}</span>}
                    </div>
                </FormGroup>
              
                <FormGroup className="Col-4-3" label="Stock Name(Big5)" labelFor="inputStkName">
                    <InputGroup id="inputStkName" name="d_Chi_Name_bg5" defaultValue="" placeholder="Big5 Stock Name ..." inputRef={register({ maxLength: 45}) } />
                    {errors.d_Chi_Name_bg5 && errors.d_Chi_Name_bg5.type === "maxLength" && <span id="Err_msg">Max length is 45</span>}
                    <div>
                        {errors.d_Chi_Name_bg5 && errors.d_Chi_Name_bg5.types && <span id="Err_msg">{errors.d_Chi_Name_bg5.types.message}</span>}
                    </div>
                </FormGroup>               



            </div>
            <div className="Spacing-V-16" />
            <div className="Row">                
                <FormGroup className="Col-1-2" label="Apply Price." labelFor="inputApplyPrice" >
                    <InputGroup id="inputApplyPrice" name="d_ApplyPrice"  autoFocus={! isNew} onChange={utils.handleStringChange(n => setApplyPriceValue(n))} inputRef={register({ required: false }) } />                  
                    {errors.d_ApplyPrice && errors.d_ApplyPrice.types && <span id="Err_msg">{errors.d_ApplyPrice.types.message}</span>}
                </FormGroup >

                <FormGroup className="Col-1-2" label="Lot Size." labelFor="inputLotSize" >
                    <InputGroup id="inputTradingFee" name="d_LotSize" type="number" autoFocus={! isNew} onChange={utils.handleStringChange(n => setLotSizeValue(n))} inputRef={register({ required: false }) } />        
                    {errors.d_LotSize && errors.d_LotSize.types && <span id="Err_msg">{errors.d_LotSize.types.message}</span>}                    
                </FormGroup >
                {(GsbFlag.MULTI_MKT) && ( ! GsbFlag.SING_CURR) &&
                    <FormGroup className="Col-3-2" label="Currency" labelFor="inputCurrency">
                             <Suggest2
                                inputProps={{ placeholder: "Currency ..." }}
                                query={CurrencyValue}
                                onQueryChange={(queryText) => {
                                    setCurrencyValue(queryText);
                                }}
                                activeItem={CurrencyList.find((Ccy) => Ccy.d_Currency === CurrencyValue)}
                                selectedItem={CurrencyList.find((Ccy) => Ccy.d_Currency === CurrencyValue)}
                                items={CurrencyList}
                                itemRenderer={CurrencyRenderer}
                                itemPredicate={CurrencyPredicate}
                                inputValueRenderer={CurrencyValueRenderer}
                                onItemSelect={(item) => {setCurrencyValue(item.d_Currency); 
                                }}
                            />
                        {errors.d_Currency && errors.d_Currency.types && <span id="Err_msg">{errors.d_Currency.types.message}</span>}
                    </FormGroup>
                }              
            </div>           

            <div className="Spacing-V-16" />
            <div className="Row">
                 <FormGroup className="Col-1-2" label="Apply date" labelFor="inputApplyDate">
                     <InputGroup id="inputApplyDate" name="d_ApplyDate" type="date" placeholder="YYYY-MM-DD" leftIcon="calendar" inputRef={register} /> 
                    {errors.d_ApplyDate && errors.d_ApplyDate.types && <span id="Err_msg">{errors.d_ApplyDate.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-3-2" label="Listing date" labelFor="inputListingDate">
                    <InputGroup id="inputOLDATE" name="d_ListingDate" type="date"  placeholder="YYYY-MM-DD" leftIcon="calendar" inputRef={register} />
                    {errors.d_ListingDate && errors.d_ListingDate.types && <span id="Err_msg">{errors.d_ListingDate.types.message}</span>}
                </FormGroup>     

            </div>      
        
     
            <div className="Row">
                <FormGroup className="Col-1-2" label="Comm Rate.(%)" labelFor="inputCommRate" >

                {/*<InputGroup id="inputCommRate" name="d_CommRate" type="number" defaultValue={utils.formatNumber4(d_LevyRate)} value={utils.formatNumber4(d_LevyRate)}  onChange={utils.handleNumberChange(n => setd_LevyRate(n))}  autoFocus={! isNew} inputRef={register({ required: true }) } />*/}
                <InputGroup id="inputCommRate" name ="d_CommRate" type="text"   onChange={utils.handleStringChange(n => setCommRateValue(n))}  inputRef={register({ required: false }) } />
                    {/*<InputGroup id="inputCommRate" name ="d_CommRate" type="number"  defaultValue=""  inputRef={register({ required: false }) } />*/}
                    {errors.d_CommRate && errors.d_CommRate.types && <span id="Err_msg">{errors.d_CommRate.types.message}</span>}
                </FormGroup >
                 {/*
                <FormGroup className="Col-1-2" label="CCASS Stock" labelFor="inputCCASSstock" >
                        <InputGroup id="inputCommRate" name ="d_CCASStock" type="text" defaultValue={(d_CCASStock)} value={d_CCASStock} onChange={utils.handleStringChange(n => setd_CCASStock(n))}  inputRef={register({ required: false }) } />
                        {errors.d_CCASStock && errors.d_CCASStock.types && <span id="Err_msg">{errors.d_CCASStock.types.message}</span>}
                </FormGroup >

                */}
                <FormGroup className="Col-1-2" label="CCASS Stock" labelFor="inputCCASSstock">
                    <RadioGroup
                        name="d_CCASStock"  
                        inline={true}
                        selectedValue={CCassValue}
                        onChange={utils.handleStringChange(s => setCCassValue(s)) }
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                    {errors.d_CCASStock && errors.d_CCASStock.types && <span id="Err_msg">{errors.d_CCASStock.types.message}</span>}
                </FormGroup>



                <FormGroup className="Col-1-2" label="Contract Stamp" labelFor="inputStamp">
                    <RadioGroup
                        name="d_Stamp"
                        inline={true}
                        selectedValue={StampValue}
                        onChange={utils.handleStringChange(s => setStampValue(s)) }
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                    {errors.d_Stamp && errors.d_Stamp.types && <span id="Err_msg">{errors.d_Stamp.types.message}</span>}
                </FormGroup>

            </div>

            <div className="Row">
                {/*efaultValue={Qty3Value} value={Qty3Value} onChange={utils.handleStringChange(n => setQty3Value(n))}  /> */}
               <FormGroup className="Col-1-2" label="Transaction Levy (%)" labelFor="inputLevyRate" >
                    <InputGroup id="inputLevy" name="d_LevyRate" defaultValue={Levy_RateValue} value={Levy_RateValue} onChange={utils.handleStringChange(n => setLevy_RateValue(n))} />
                    {/*<InputGroup id="inputLevyRate" name="d_LevyRate" type="text"  defaultValue={(d_LevyRate)} value={(d_LevyRate)}  onChange={utils.handleStringChange(n => setd_LevyRate(n))}  autoFocus={! isNew} inputRef={register({ required: true }) } />*/}
                    {/*<InputGroup id="inputLevyRate" name="d_LevyRate" type="number"  autoFocus={! isNew} inputRef={register({ required: false }) } />   */}                                  
                    {errors.d_LevyRate && errors.d_LevyRate.types && <span id="Err_msg">{errors.d_LevyRate.types.message}</span>}
                </FormGroup >

                {  <FormGroup className="Col-3-2" label="AFRC Levy Rate(%)" labelFor="inputAFRCLevyRate" >
                    {/*<InputGroup id="inputTradeRate" name="d_TradingFeeRate" type="number" autoFocus={! isNew} inputRef={register({ required: false }) } />*/}
                {/* <InputGroup id="inputAFRCLevyRate" name="d_AFRCLevyRate" type="text"  defaultValue={(GsbConfig.x_FLEVY_RATE)} value={(d_AFRCLevyRate)}  onChange={utils.handleStringChange(n => setd_AFRCLevyRate(n))}  autoFocus={! isNew} inputRef={register({ required: true }) } />*/}

                    <InputGroup id="inputFLevy" defaultValue={AFRCFLevy_RateValue} value={AFRCFLevy_RateValue} onChange={utils.handleStringChange(n => setAFRCFLevy_RateValue(n))} />
                    {errors.d_AfrcLevyRate && errors.d_AfrcLevyRate.type === "min" && <span id="Err_msg">AFRC Levy Rate sholud be greater than 0 </span>}
                    {errors.d_AfrcLevyRate && errors.d_AfrcLevyRate.types && <span id="Err_msg">{errors.d_AfrcLevyRate.types.message}</span>}                
                </FormGroup >
                }

                <FormGroup className="Col-5-2" label="Trading Fee (%)" labelFor="inputTradeRate" >
                    <InputGroup id="inputTradeRate" defaultValue={SLevy_RateValue} value={SLevy_RateValue} onChange={utils.handleStringChange(n => setSLevy_RateValue(n))} />                                     

                    {/*<InputGroup id="inputTradeRate" name="d_TradingFeeRate" type="number" autoFocus={! isNew} inputRef={register({ required: false }) } />*/}
                    {/*<InputGroup id="inputLevyRate" name="d_TradingFeeRate" type="text"  defaultValue={(d_TradingFeeRate)} value={(d_TradingFeeRate)}  onChange={utils.handleStringChange(n => setd_TradingFeeRate(n))}  autoFocus={! isNew} inputRef={register({ required: true }) } />*/}
                </FormGroup >               
                <FormGroup className="Col-7-2" label="Nominee Handling Fee" labelFor="inputCommRate" >
                    <InputGroup id="inputCommRate" name ="d_HandlingFee" type="text"   value={HandlingFeeValue} onChange={utils.handleStringChange(n => setHandlingFeeValue(n))}  inputRef={register({ required: false }) } />
                    {errors.d_HandlingFee && errors.d_HandlingFee.types && <span id="Err_msg">{errors.d_HandlingFee.types.message}</span>}
                </FormGroup >   
 
             
            </div>  
            
        </form>
    )
}

interface PlacingMastMainProps {
    gsb: AxiosInstance
}

const toaster = Toaster.create({
    position: Position.TOP,
})

function PlacingMastMain({ gsb }: PlacingMastMainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    let url = document.location.toString()
    let qString = url.substr(url.indexOf("?"))

    let { acCode: defaultSearchValue = "" }: { acCode: string } = useParams()

    let logKey = utils.getUrlParameter('logKey', url); 
    let logKey2 = logKey.substr(0,logKey.indexOf("?")); 
    let logviewonly = utils.getUrlParameter('logviewonly', url); 
 
    const [data, setData] = useState([] as PlacingInfo[])
    
    const [CurrencyList, setCurrencyList] = useState([] as CurrencyInfo[])
    const [CurrencyList2, setCurrencyList2] = useState([] as CurrencyInfo[])
 
    const [currentSbConfig, setCurrentSbConfig] = useState({} as sbConfig)
    const [BlankSbConfig, setBlankSbConfig] = useState({} as sbConfig)  

    
    const [searchKey, setSearchKey] = useState("StkNo")
    const [searchValue, setSearchValue] = useState(defaultSearchValue)
    const [searchStkName, setsearchStkName] = useState("")
    const [searchApplyDate, setsearchApplyDate] = useState("")

    const [searchStkNo, setsearchStkNo] = useState("")        
    const [searchStk, setsearchStk] = useState("")

    const [showFilters, setShowFilters] = useState(false)

    const [searchIdNo, setSearchIdNo] = useState("")
    const [searchSMPID,setSearchSMPID] = useState("")
    //const [searchEcpRdStatus,setsearchEcpRdStatus] = useState("")
    const [searchCrsStatus,setsearchCrsStatus] = useState("")
    const [searchHolderType,setsearchHolderType] = useState("")
   
    

    const [searchName, setSearchName] = useState("")
 
    const [def_id_Type, setid_Type] = useState("")

    const [searchTel, setSearchTel] = useState("")


    const [s_AcStatus, sets_AcStatus] = useState("")

    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [aPageShowInfo, setaPageShowInfo] = useState([] as PageInfo2[])
    const [PageReachEnd, setPageReachEnd] = useState(false)
    const [MoblieDev, setMoblieDev] = useState(false)
    const [ShowWait, setShowWait] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("list")
    const [currentAc, setCurrentAc] = useState({} as PlacingInfo)
    const [currentAc2, setCurrentAc2] = useState({} as PlacingInfo)


    //PlacingInfo
    const [BlankAc, setBlankAc] = useState({} as PlacingInfo)
    const [CurrentLog1, setCurrentLog1] = useState({} as PlacingInfo)
    const [CurrentLog0, setCurrentLog0] = useState({} as PlacingInfo)
    const [ViewMode, setViewMode] = useState("V")



    const [currentMode, setCurrentMode] = useState("show")
    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")
    const [SUSPEND_AC, setSUSPEND_AC] = useState(false)
    
    const [showCurrency, setshowCurrency] = useState(false)
    const { t, i18n } = useTranslation();
 
    BlankAc.d_Currency="HKD"
   
    // BlankIPO.d_StkNo =""

    BlankAc.d_CommRate =   utils.StringToNum("1.0000")   // 1.
    
    // show last stk
    BlankAc.d_StkNo = currentAc2.d_StkNo
    BlankAc.d_CCASStock = "Y"
    BlankAc.d_Stamp = "Y"
   
      //Pre-Paid Ratio (%)
 
  //  BlankAc.d_OPAYPERC ="100.00"
    BlankAc.d_AfrcLevyRate =   utils.StringToNum(currentSbConfig.x_FLEVY_RATE)   //"0.00015"   //AFRC rate
   // BlankAc.d_LevyRate ="0.0005"     //Levy rate
    BlankAc.d_LevyRate =  utils.StringToNum(currentSbConfig.x_LEVY_RATE)
    BlankAc.d_TradingFeeRate =  utils.StringToNum(currentSbConfig .x_SLEVY_RATE) // "0.00565"    //Tradeing rate   A Trading Fee of 0.00565%
 
  
    BlankAc.d_HandlingFee = utils.StringToNum("100")
 

     useEffect(() => {
         (async () => {
             try {
                 // get GsbFlag from SB.XBS
                 const res = await gsb.post('/GsbFlag');
                 //console.log("PayRecTranEntryMain disp user_key: ", res.data.Flag.user_key)
                 //console.log("PayRecTranEntryMain disp MULTI_MKT: ", res.data.Flag.MULTI_MKT)
                 //console.log("PayRecTranEntryMain disp data.Flag: ", res.data.Flag)
                 GsbFlag = res.data.Flag;
                 //console.log("PayRecTranEntryMain disp GsbFlag: ", GsbFlag)
                 //console.log("PayRecTranEntryMain disp GsbFlag.lang: ", GsbFlag.lang)
                 //console.log("PayRecTranEntryMain disp GsbFlag.dateFormat: ", GsbFlag.dateFormat)
                 console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                 //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                 UserID = res.data.Flag.UserID
                 //console.log("PayRecTranEntryMain disp GsbFlag.MULTI_MKT: ", sbFlag.MULTI_MKT)
                 //console.log("PayRecTranEntryMain disp GsbFlag.MGNGP_USER: ", GsbFlag.MGNGP_USER)
                 //console.log("PayRecTranEntryMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                 setCO_NAME( GsbFlag.CO_NAME) ;
                 setcompanyLogoName( GsbFlag.companyLogoName) ;
                 setSBPath( GsbFlag.SBPath) ;
                 setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                 setSETL_DATE(GsbFlag.SETL_DATE ) ;
                 if ( GsbFlag.isProduction == "Y" ) {
                     setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                 } else {
                     setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                 }
 
                 setshowCurrency( (GsbFlag.MULTI_MKT) && ( ! GsbFlag.SING_CURR) );
              
             } catch (error) {
                 utils.showError(error)
             }
         })()
     }, [gsb])

    useEffect(() => {
 
        (async () => {
            try {
                const res = await gsb.post('/Master',
                    {   sb_data: {
                            by: "",
                            start: "",
                            nPage: 1,
                            limit: 0,
                            backward: false,
                            SortByName: false,    
                        },
                        cPgmId: "GsbConfig",
                        cAction: "ListRec",
                    });
              
                    
                if (res.data.data.length > 0) {
                    setCurrentSbConfig(res.data.data[0])
                }

                console.log("main res.data", res.data.data)
                console.log("main currentAc", currentSbConfig)
                //setCurrentMode("show")

             
                

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])


    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');        
                GsbFlag = res.data.Flag;
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
             
                UserID = res.data.Flag.UserID  
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
                setSUSPEND_AC(GsbFlag.SUSPEND_AC);

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        (async () => {
            try {
                // get Market List
                const res = await gsb.post('/Master', {sb_data: "", cPgmId: "ExchangeRate", cAction: "GetCCYList"})

                //console.log("MarketList: ", res.data.data) 
                CurrencyList2.push({d_Currency: "", d_CcyDesc: "HKD"})
                for (let j = 0; j < res.data.data.length; j++) {
                    CurrencyList2.push({d_Currency: res.data.data[j][0], d_CcyDesc: res.data.data[j][1]})
                }
                setCurrencyList(CurrencyList2)
                //console.log("set CurrencyList: ", CurrencyList) 
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    //console.log("PlacingMastMain UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            //setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID])


    useEffect(() => {
        if (logviewonly === "Y") {
            setViewMode("L")
        }
        
        ;
        (async () => {
            try {
                if ( logKey.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_logKey: logKey,
                        }, 
                        cPgmId: "PlacingMast", 
                        cAction: "ViewLogRec"
                    })
                    //console.log("PlacingMastMain ViewLogRec res.data.data", res.data.data)

                    if (res.data.ok) {
                        setCurrentLog0(res.data.data[0])
                        setCurrentLog1(res.data.data[1])
                    } else {
                        utils.showWarn(res.data.data)
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, logKey])
 
 

    const PrevRecProcess = async (Placing: PlacingInfo) => {
        try {
            //console.log("call PrevRecProcess", ac)
            const res = await gsb.post('/Master', {sb_data: Placing, cPgmId: "PlacingMast", cAction: "PrevRec"})
            //console.log("PrevRecProcess res.data : ", res.data.data)
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_StkNo === res.data.data.d_StkNo) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")

        } catch (error) {
            utils.showError(error)
        }
    }
 
   
  
    const DeleteProcess = async (Placing: PlacingInfo) => {
        try {
            Placing.d_AuthTran = ""
            if (isReqAuth2) {
                Placing.d_AuthTran = "Y"
            }
            //console.log("call DeleteProcess", stk)
            const res = await gsb.post('/Master', {sb_data: Placing, cPgmId: "PlacingMast", cAction: "DelRec"})
            if (res.data.ok) {
                if (isReqAuth2) {
                    showSuccess("Stock No. " + Placing.d_StkNo + "[" + Placing.d_StkNo +"] record deleting, waiting for authorization")
                } else {
                    showSuccess("Stock No. " + Placing.d_StkNo + "[" + Placing.d_StkNo +"] record deleted")
                    for (let i = 0; i < data.length; i++) {
                        if (data[i].d_StkNo === res.data.data.d_StkNo) {
                            data[i] = { ...data[i], ...res.data.data }
                            setData(data)
                            break
                        }
                    }
                }
                setCurrentAc(res.data.data)               
                setCurrentMode("show")
                if (isReqAuth2) {
                    alert("Stock No. " + Placing.d_StkNo + "[" + Placing.d_StkNo +"]  record deleting, waiting for authorization")
                }
            } else {
                setisShowAlert2(true)
                setShowAlert2Msg(res.data.err_Msg)
            }
        } catch (error) {
            utils.showError(error)
        }
    }

    const NextRecProcess = async (Placing: PlacingInfo) => {
        try {
            console.log("call NextRecProcess", Placing)
            const res = await gsb.post('/Master', {sb_data: Placing, cPgmId: "PlacingMast", cAction: "NextRec"})
            //console.log("NextRecProcess show 1: ", stk.d_StkNo)
            console.log("NextRecProcess data : ", data)
            console.log("NextRecProcess res.data : ", res.data.data)
                //console.log("PrevRecProcess res.data.data : ", res.data.data)
            setCurrentAc(res.data.data)
            //console.log("PrevRecProcess show 2: ", stk.d_StkNo)
            setCurrentMode("show")
            //console.log("PrevRecProcess show 3: ", stk.d_StkNo)
        } catch (error) {
            utils.showError(error)
        }
    }

    const newOnSave = async (Placing: PlacingInfo) => {
        try {
            //console.log("call newOnSave", Placing)
            const res1 = await gsb.post('/GsbFlag');
            //console.log("MenuBar disp user_key: ", res.data.Flag.user_key)
            GsbFlag = res1.data.Flag;
            


            //console.log("MenuBar disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
            const res = await gsb.post('/Master', {sb_data: Placing, cPgmId: "PlacingMast", cAction: "AddRec"})
            if (isReqAuth2) {
                showSuccess(" Stock No. [" + Placing.d_StkNo + "] record adding, waiting for authorization")
            } else {
                showSuccess(" Stock No. [" + Placing.d_StkNo + "] record added")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_StkNo === res.data.data.d_StkNo) {
                        data[i] = { ...data[i], ...res.data.data }
                        data[i].d_StkCode = data[i].d_StkCode.toUpperCase()
                        data[i].d_StkName = data[i].d_StkName.toUpperCase()
                        setData(data)
                        break
                    }
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
            if (isReqAuth2) {
                alert(" Stock No. [" + Placing.d_StkNo + "] record adding, waiting for authorization")
            }
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }


    const editOnSave = async (Placing: PlacingInfo) => {
        try {
            console.log("call editOnSave", Placing)
             //console.log("call newOnSave", Placing)
            const res1 = await gsb.post('/GsbFlag');
             //console.log("MenuBar disp user_key: ", res.data.Flag.user_key)
            GsbFlag = res1.data.Flag;
             


            console.log("call PlacingMastEdit data", data)
            //const res3 = await gsb.post('/Master', {sb_data: data, cPgmId: "PlacingMast", cAction: "PlacingMastValidate", isNew: false})
       
            const res = await gsb.post('/Master', {sb_data: Placing, cPgmId: "PlacingMast", cAction: "UpdateRec"})
            if (isReqAuth2) {
                console.log("StkNo No. " + Placing.d_StkNo + " record saving, waiting for authorization")
               showSuccess("StkNo No. " + Placing.d_StkNo + " record saving, waiting for authorization")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_StkNo === res.data.data.d_StkNo) {

                        data[i].d_StkCode = data[i].d_StkCode.toUpperCase()
                        data[i].d_StkName = data[i].d_StkName.toUpperCase()
                        setCurrentAc(data[i])
                        break
                    }
                }
                setCurrentMode("show")
                //alert("Account No. " + Bcan.d_acCode + " record saving, waiting for authorization")
                setisShowAlert1(true)
                setShowAlert1Msg("StkNo No. " + Placing.d_StkNo + " record saving, waiting for authorization")
                console.log("StkNo No. " + Placing.d_StkNo + " record saving, waiting for authorization")
            } else {
           
                console.log("Stock No. " +Placing.d_StkNo + " record saved")
                showSuccess("Stock No. " +Placing.d_StkNo + " record saved")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_StkNo === res.data.data.d_StkNo) {
                        data[i] = { ...data[i], ...res.data.data }
                        setData(data)
                        break
                    }
                }
                setCurrentAc(res.data.data)
                setCurrentMode("show")
                console.log("call editOnSaved", Placing)
                
            }
        } 
        catch (error) {
            utils.showError(error)
        }
        
    }

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()

        setShowWait(true)
        setnPage(0)
        setnTotalPage(0)
        setPageReachEnd(false)

        let m_limit = searchLimit
        if ( selectedTabId === "detail" ) {
            m_limit = 1
        }

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }

        try {
            if ( m_limit > 1 ) {
                const res = await gsb.post('/Master',
                {   sb_data: {
                        by: searchKey,
                        start: searchValue,
                        nPage: 1,
                        limit: m_limit,
                        PageShowInfo: aPageShowInfo,
                        refreshPageShow: true,
                        backward: searchBackward,
                        SortByName: false,
                        filters: {
                            Stk: searchStk,
                            StkName: searchStkName,
                            AppyDate:searchApplyDate,
                        },
                    },
                    cPgmId: "PlacingMast",
                    cAction: "ListRec",
                });

                console.log("ListRec2 res.data.data", res.data.data)
                console.log("ListRec2 res.data.count", res.data.count)
                setData(res.data.data)
                setaPageShowInfo(res.data.PageShowInfo)

                if (res.data.data.length > 0) {
                    setCurrentAc(res.data.data[0])
                }

                if ( res.data.count > 0 ) {
                    {/*
                    const aPageNumber1 = []
                    if ( res.data.count > 0 ) {
                        setnTotalPage(Math.ceil(res.data.count / searchLimit))
                        for ( let j = 1; j <= Math.ceil(res.data.count / searchLimit); j++ ) {
                            aPageNumber1.push({n: j});
                        }
                        setaPageNumber(aPageNumber1)
                    }
                    */}
                  
                    const aPageNumber1 = []
                    let k = 0
                    for ( let j = 1; j <= res.data.PageShowInfo.length; j++ ) {
                        if ( res.data.PageShowInfo[j-1].pageShow ) {
                            k++
                            aPageNumber1.push({n: res.data.PageShowInfo[j-1].pageno});
                            if ( res.data.PageShowInfo[j-1].pageLast ) { 
                                setnTotalPage(res.data.PageShowInfo[j-1].pageno)
                                setPageReachEnd(true)
                            }
                        }
                    }
                    setaPageNumber(aPageNumber1)
                    setnPage(1)
                    console.log("ListRec k", k, aPageNumber1)
                } else {
                    setnPage(0)
                    setnTotalPage(0)
                   
                }
            } else {
                const res = await gsb.post('/Master',
                {   sb_data: {
                        d_StkNo: searchValue,
                        nPage: 1,
                        limit: m_limit,
                    },
                    cPgmId: "PlacingMast",
                    cAction: "GetRec",
                });

                if ( res.data.ok ) {
                    console.log("GetRec res.data.data", res.data.data)
                    setCurrentAc(res.data.data)
                    setCurrentMode("show")
                } else {
                    //alert(res.data.data)
                    setisShowAlert2(true)
                    setShowAlert2Msg(res.data.data)
                }
            }
            setShowWait(false)
        } catch (error) {
            setShowWait(false)
            utils.showError(error)
        }
    }

    //Press page No 1 2 3 4
    useEffect(() => {
        if ( nPage > 0 && selectedTabId == "list" ) {
    
            setShowWait(true)
            setPageReachEnd(false)

            ;
    
            (async () => {
                try {
                    //console.log("IntRMastMain useEffect nPage > 0  ", nPage)
                    const res = await gsb.post('/Master',
                    {   sb_data: {
                            by: searchKey,
                            start: searchValue,
                            nPage: nPage,
                            limit: searchLimit,
                            PageShowInfo: aPageShowInfo,
                            refreshPageShow: false,
                            backward: searchBackward,
                            SortByName: false,                        
                            },
                        cPgmId: "PlacingMast",
                        cAction: "ListRec",
                    });

                    setData(res.data.data)

                    console.log("PlacingMast.data.data > 0  ", res.data.data)
                    setaPageShowInfo(res.data.PageShowInfo)

                    if (res.data.data.length > 0) {
                        setCurrentAc(res.data.data[0])
                    }
/*
                    if ( res.data.count > 0 ) {
                        const aPageNumber1 = []
                        let k = 0
                        for ( let j = 1; j <= res.data.PageShowInfo.length; j++ ) {
                            if ( res.data.PageShowInfo[j-1].pageShow ) {
                                k++
                                aPageNumber1.push({n: res.data.PageShowInfo[j-1].pageno});
                                if ( res.data.PageShowInfo[j-1].pageLast ) { 
                                    setnTotalPage(res.data.PageShowInfo[j-1].pageno)
                                    setPageReachEnd(true)
                                }
                            }
                        }
                        setaPageNumber(aPageNumber1)
                        //console.log("ListRec Press k", k, aPageNumber1)
                    }
                   
*/
                    setShowWait(false)
        
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, nPage, selectedTabId])


    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    const showError = (err: any) => {
        if (err.response) {
            toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        } else if (err.request) {
            toaster.show({ message: "Request failed", intent: Intent.WARNING })
        } else {
            toaster.show({ message: err.message, intent: Intent.WARNING })
        }
    }

    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }

    // currentMode = show
    let detail = <PlacingMastView gsb={gsb} Placing={currentAc} Placing0={currentAc}  CurrencyList={CurrencyList} GsbConfig={currentSbConfig}  baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentAc)} onNew={() => setCurrentMode("new")}  onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentAc)} onNextRec={() => NextRecProcess(currentAc)} ViewMode={ViewMode} logKey2={logKey2.trim()} PgmMode="PlacingMast" ></PlacingMastView>
    switch (currentMode) {
        case "edit":
          
            detail = <PlacingMastEdit gsb={gsb} Placing={currentAc} CurrencyList={CurrencyList}  GsbConfig={currentSbConfig}  onSave={editOnSave} onCancel={() => setCurrentMode("show")} PgmMode="PlacingMast" ></PlacingMastEdit>
            break
        case "new":
            //detail = <BrokerTranEntryEdit gsb={gsb} BrokerTran={BlankBrokerTran} isNew onSave={newOnSave} onCancel={() => { setCurrentMode("show"); setSelectedTabId("detail") } } ></BrokerTranEntryEdit>

            console.error("new" )
            detail = <PlacingMastEdit gsb={gsb} Placing={BlankAc} CurrencyList={CurrencyList} GsbConfig={currentSbConfig}  isNew onSave={newOnSave} onCancel={() => { setCurrentMode("show"); setSelectedTabId("detail") } } PgmMode="PlacingMast" ></PlacingMastEdit>
            break
    }

    //let logKeyViewRec = <PlacingMastView gsb={gsb} Placing={CurrentLog1} Placing0={CurrentLog0}  baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentAc)} onNew={() => setCurrentMode("new")}  onReplicate={() => ReplicateProcess(currentAc)} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentAc)} onNextRec={() => NextRecProcess(currentAc)} ViewMode={ViewMode} logKey2={logKey2.trim()} PgmMode="HKCRS"  ></PlacingMastView>

    let logKeyViewRec = <PlacingMastView gsb={gsb} Placing={CurrentLog0} Placing0={CurrentLog1}  GsbConfig={currentSbConfig} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentAc)} onNew={() => setCurrentMode("new")}  onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentAc)} onNextRec={() => NextRecProcess(currentAc)} ViewMode={ViewMode} logKey2={logKey2.trim()} PgmMode="PlacingMast"  ></PlacingMastView>
    function PageNo(n: number) {
        if (n > 0 ) {
            if (  nPage+n <= nTotalPage || nTotalPage == 0 ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }


 
 
    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page
                { (nPage > 0) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                 {aPageNumber.map((no, j) => 
                    (no.n < nPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (no.n > nPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nPage > 0) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
                { (nPage > 0) && ! ( PageReachEnd ) &&
                    <Button minimal >...</Button>
                }
            </FormGroup>
        </div>
    </>
 

    
    let list = <>
        <div className="Row">
            <Button className="Col-1-1" icon="add" onClick={() => { setCurrentMode("new"); setSelectedTabId("detail") }}>New</Button>
        </div>
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
        {/* display search list */}
        <HTMLTable striped interactive condensed>
            <thead>                                  
                <th className="TCol-StkCode">Stock No.</th>
                <th className="TCol-StkNo">Stock Code</th>
                <th className="TCol-StkCode">Stock Name</th>
                <th className="TCol-StkCode">Stock Name(Big5)</th>
                <th className="TCol-IPO">Apply Price</th>
                <th className="TCol-Ex_date">Lot Size</th>     
                <th className="TCol-Ex_date">Comm Rate</th>     
                <th className="TCol-Ex_date">Handling Fee</th>     
                <th className="TCol-Ex_date">CCass Stock</th>                                              
                <th className="TCol-Ex_date">Require Stamp</th>    

                <th className="TCol-Ex_date">Transaction Levy Rate</th>    
                <th className="TCol-Ex_date">AFRC Levy Rate</th>    
                <th className="TCol-Ex_date">Trading Fee Rate</th>    
                <th className="TCol-Ex_date">Handling Fee</th>    

                <th className="TCol-PY_date">Apply Date</th>   
                <th className="TCol-PY_date">Listing Date</th>  
            </thead>
            <tbody id="ma_tr">
                {data.map((Placing, i) =>
                    <tr key={i} onDoubleClick={() => { setSelectedTabId("detail") }}>
                  
                        <td className="TCol-StkCode" onClick={() => { setCurrentAc(Placing) ; MoblieDev && setSelectedTabId("detail") }}>{Placing.d_StkNo}</td>                        
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(Placing) ; MoblieDev && setSelectedTabId("detail") }}>{Placing.d_StkCode}</td>
                        <td className="TCol-StkCode" onClick={() => { setCurrentAc(Placing) ; MoblieDev && setSelectedTabId("detail") }}>{Placing.d_StkName}</td>
                        <td className="TCol-StkCode" onClick={() => { setCurrentAc(Placing) ; MoblieDev && setSelectedTabId("detail") }}>{Placing.d_Chi_Name_bg5}</td>                   
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(Placing) ; MoblieDev && setSelectedTabId("detail") }}>{utils.formatNumber(Placing.d_ApplyPrice)}</td>
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(Placing) ; MoblieDev && setSelectedTabId("detail") }}>{Placing.d_LotSize}</td>     
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(Placing) ; MoblieDev && setSelectedTabId("detail") }}>{utils.ParseFloat(Placing.d_CommRate,4)}</td>     
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(Placing) ; MoblieDev && setSelectedTabId("detail") }}>{utils.ParseFloat(Placing.d_HandlingFee,2)}</td>     
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(Placing) ; MoblieDev && setSelectedTabId("detail") }}>{Placing.d_CCASStock}</td>     
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(Placing) ; MoblieDev && setSelectedTabId("detail") }}>{Placing.d_Stamp}</td>      
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(Placing) ; MoblieDev && setSelectedTabId("detail") }}>{Placing.d_LevyRate}</td>      
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(Placing) ; MoblieDev && setSelectedTabId("detail") }}>{Placing.d_AfrcLevyRate}</td>      
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(Placing) ; MoblieDev && setSelectedTabId("detail") }}>{Placing.d_TradingFeeRate}</td>      
                   
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(Placing) ; MoblieDev && setSelectedTabId("detail") }}>{Placing.d_HandlingFee}</td>      
                   
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(Placing) ; MoblieDev && setSelectedTabId("detail") }}>{Placing.d_ApplyDate }</td>
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(Placing) ; MoblieDev && setSelectedTabId("detail") }}>{Placing.d_ListingDate }</td>
                    </tr>
                )}
            </tbody>
        </HTMLTable>
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
    </>

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>
    return (
        <>
            <form onSubmit={onSubmit}>
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                { ! ( logviewonly === "Y" ) && <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H4><div style={{justifyContent: 'flex-end'}}>Placing Master</div></H4>
                    <div className="Row No-Print">
                        <FormGroup className="Col-1-5" label="Search for" labelFor="inputSearchValue">
                            <ControlGroup fill>
                                <HTMLSelect className={Classes.FIXED} value={searchKey} onChange={utils.handleStringChange(s => setSearchKey(s))}>                                   
                                    <option value="StkNo">StockNo</option>
                                    <option value="StkName">StockName</option>
                                                                      
                                    {/* <option value="_recordNo">Record No.</option> */}
                                </HTMLSelect>
                                <InputGroup
                                    id="inputSearchValue"
                                    placeholder="Search"
                                    value={searchValue}
                                    onChange={utils.handleStringChange(s => setSearchValue(s))}
                                    leftIcon="search"
                                    rightElement={<Button icon={IconNames.ARROW_RIGHT} disabled={(selectedTabId === "detail" && ! (searchKey == "acCode"))} minimal type="submit"></Button>}
                                />
                            </ControlGroup>
                        </FormGroup>
                        <Button className="Col-6-1 Button-LabeledFormGroup" icon="search" disabled={(selectedTabId === "detail" && ! (searchKey == "acCode"))} type="submit" >{(selectedTabId === "detail") ? "Search" : "List"}</Button>
                        {/* <Checkbox className="Col-6-1 Checkbox-LabeledFormGroup" label="Backward" onChange={utils.handleBooleanChange(v => setSearchBackward(v))} /> */}
                        <Button className="Col-7-1 Button-LabeledFormGroup" icon="filter" onClick={() => { setShowFilters(!showFilters) }} >Filters</Button>
                    </div>
                    <Collapse isOpen={showFilters}>
                        <div className="Row">
                            {/* define search filter */}
                            <FormGroup className="Col-1-2" label="Appy Date" labelFor="searchApplyDate">
                               <InputGroup id="searchApplyDate"   value={searchApplyDate} type ="date"  placeholder="YYYY-MM-DD" onChange={utils.handleStringChange(s => setsearchApplyDate(s))} />
                            </FormGroup>
                            <FormGroup className="Col-1-2" label="Stock Code" labelFor="searchStk">
                                <InputGroup id="searchStk" value={searchStk} onChange={utils.handleStringChange(s => setsearchStk(s))} />
                            </FormGroup>
                            <FormGroup className="Col-1-2" label="Stock Name." labelFor="searchStkName">
                                <InputGroup id="searchStkNo" value={searchStkName} onChange={utils.handleStringChange(s => setsearchStkName(s))} />
                            </FormGroup>
                            
                            {/* <FormGroup className="Col-6-2" label="No. of record(s) to List" labelFor="searchLimit" >
                                <InputGroup className="Input-XS" id="searchLimit" value={searchLimit.toString()} onChange={utils.handleNumberChange(n => setSearchLimit(n))} />
                            </FormGroup> */}
                        </div>
                    </Collapse>
                  
                    <Tabs onChange={(newTabId) => setSelectedTabId(newTabId as string)} selectedTabId={selectedTabId}>
                        <Tab id="list" title="List" panel={list} />
                        <Tab id="detail" title="Detail" panel={detail} />
                    </Tabs>
                </Card> }
                {ViewMode === "L" && <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>Placing Log View</H3>
                    <div className="Spacing-V-16" />
                    {logKeyViewRec}















                    
                </Card> }

                <div className="Spacing-V-16"></div>
                    <Alert
                        confirmButtonText="OK"
                        icon="tick-circle"
                        intent={Intent.SUCCESS}
                        isOpen={isShowAlert1}
                        onCancel={ () => setisShowAlert1(false) }
                        onConfirm={ () => { setShowAlert1Msg(""); setisShowAlert1(false) } }
                    >
                        <p>
                            {ShowAlert1Msg}
                        </p>
                    </Alert>
                    <Alert
                        confirmButtonText="OK"
                        icon="cross"
                        intent={Intent.WARNING}
                        isOpen={isShowAlert2}
                        onCancel={ () => setisShowAlert2(false) }
                        onConfirm={ () => { setShowAlert2Msg(""); setisShowAlert2(false) } }
                    >
                        <p>
                            {ShowAlert2Msg}
                        </p>
                    </Alert>
            </form>
        </>
    );
}

export default PlacingMastMain



